import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["viewTaxCard", "viewTitle", "viewTaxCardBody", "previewCard", "previewTitle", "9999"]

  connect() {
    this.controllerName = `operations--products--clinics--financials--taxes--show`

    if (this.getControllerByIdentifier("operations--products--clinics--financials--taxes--dashboard")) {
      this.dashboardController = this.getControllerByIdentifier("operations--products--clinics--financials--taxes--dashboard")
    } else if (this.getControllerByIdentifier("operations--products--clinics--clients--taxes--dashboard")) {
      this.dashboardController = this.getControllerByIdentifier("operations--products--clinics--clients--taxes--dashboard")
    }
  }

  doViewHtml() {
    var html = `<div class="card" style="width:100%;display:relative;" data-${this.controllerName}-target="viewTaxCard" data-action="resize@window->${this.controllerName}#layout">
                  <div class="card-header d-flex align-items-center card-header-table-list f-065">
                    <h6 class="card-title display-4 py-3" style="font-size:110%;margin-bottom:0px;" data-${this.controllerName}-target="viewTitle">Nenhum Imposto Selecionado</h6>
                  </div>
                  <div class="card-body py-0 px-2" style="overflow:auto;" data-${this.controllerName}-target="viewTaxCardBody"></div>
                </div>`

    this.dashboardController.viewTarget.innerHTML = html
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  layout() {
    var targets = ["mainCard"]
    var identifier = ""
    this.connect()
    // this.getControllerByIdentifier("app--helpers--layout").resizeMainCard(targets, identifier)
  }

  refreshSaveBtn() {
    var controller = this
    this.refreshTimer = setInterval(function () {
      var len = 0
      controller.validGroupTargets.forEach(element => {
        if (this.fromStringToBoolean(element.dataset.valid) == false) {
          len += 1
        }
      });
      if (len == 0) {
        controller.saveBtnTarget.disabled = false
      } else {
        controller.saveBtnTarget.disabled = true
      }
    }, 200);
  }

  stopRefreshing() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
    }
  }

  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 

}
